import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Grid, Card } from "@mui/material";
import { theme, StyledMultilineTextField } from "../StyledComponents";

const MedicalAdvice = ({ sectionName, activeSection, data, setData }) => {
  console.log(data);
  //   const [validationErrors, setValidationErrors] = useState(followUpError);

  const handleInputChange = (field, value) => {
    let updatedDetails = { ...data, [field]: value };

    setData(updatedDetails);
    // setData(updatedDetails);
    // validateFields(updatedDetails);
  };

  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          {/* <Grid item xs={12}> */}

          <Grid container spacing={2} sx={{ padding: "10px" }}>
            <Grid item xs={12} md={12} sm={12}>
              <StyledMultilineTextField
                id="outlined-multiline-static"
                label="Medical Advice"
                multiline
                rows={2}
                value={data.advice || ""}
                onChange={(e) => handleInputChange("advice", e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
          {/* </Grid> */}
        </Card>
      ) : null}
    </ThemeProvider>
  );
};

export default MedicalAdvice;
